import { useState } from "react";

const readPermissions = () => {
  try {
    return JSON.parse(localStorage.getItem("permissions"));
  } catch (error) {
    return null;
  }
};

export const usePermissionEffect = () => {
    // read synchronously so permission-gated UI doesn't flash "no access"
    // on first render
    const [permissions] = useState(readPermissions);

      const getModulePermission = (module, section) => {
        const pers = permissions?.find(
          (per) =>
            String(per?.module?.toLowerCase()) === String(module.toLowerCase()),
        )?.permissions;
        return pers ? pers[section] : false;
      };

      return { getModulePermission }
}
